var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { parseGeneratedCodeFormat, generateGeneratedCodeExample, } from '@/shared/utils/generatedCodeFormat';
var messages = defineMessages({
    AddFormatParts: { id: 'AddFormatParts', defaultMessage: 'Add format parts' },
    Counter: { id: '[Counter:Nx]', defaultMessage: '[Counter:Nx]' },
    Text: { id: 'Text', defaultMessage: 'Text' },
    CounterLabel: { id: 'CounterLabel', defaultMessage: 'Counter #' },
    Example: { id: 'Example', defaultMessage: 'Example' },
    FirstNumber: { id: 'FirstNumber', defaultMessage: 'FirstNumber' },
    Save: { id: 'Save', defaultMessage: 'Save' },
    Clear: { id: 'clear', defaultMessage: 'clear' },
    Reset: { id: 'Reset', defaultMessage: 'Reset' },
    Cancel: { id: 'Cancel', defaultMessage: 'Cancel' },
    Warning: {
        id: 'Warning',
        defaultMessage: 'Warning: changing the format only affects newly created items. Items that were already created will not be modified.',
    },
});
var serializeElements = function (elements) {
    return elements.reduce(function (result, el) {
        if (el.id === 'Text')
            return result + (el.t || '');
        if (el.id === 'Counter')
            return result + "[Counter:N".concat(el.n || 0, "]");
        return result;
    }, '');
};
var EditableGeneratedCodeFormat = function (_a) {
    var value = _a.value, onSubmit = _a.onSubmit, firstNumber = _a.firstNumber, _b = _a.showWarning, showWarning = _b === void 0 ? false : _b, _c = _a.readOnly, readOnly = _c === void 0 ? false : _c;
    var intl = useIntl();
    var _d = useState(false), editMode = _d[0], setEditMode = _d[1];
    var _e = useState([]), elements = _e[0], setElements = _e[1];
    var _f = useState(false), saving = _f[0], setSaving = _f[1];
    var hasCounter = elements.some(function (el) { return el.id === 'Counter'; });
    var startEdit = function () {
        if (readOnly)
            return;
        setElements(parseGeneratedCodeFormat(value || ''));
        setEditMode(true);
    };
    var addPart = function (type) {
        if (type === 'Counter' && hasCounter)
            return;
        var newEl = type === 'Counter' ? { id: 'Counter', n: 0 } : { id: 'Text', t: '' };
        setElements(__spreadArray(__spreadArray([], elements, true), [newEl], false));
    };
    var removePart = function (index) {
        setElements(elements.filter(function (_, i) { return i !== index; }));
    };
    var updatePart = function (index, updates) {
        setElements(elements.map(function (el, i) { return (i === index ? __assign(__assign({}, el), updates) : el); }));
    };
    var movePart = function (fromIndex, toIndex) {
        var updated = __spreadArray([], elements, true);
        var moved = updated.splice(fromIndex, 1)[0];
        updated.splice(toIndex, 0, moved);
        setElements(updated);
    };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (saving || !hasCounter)
                        return [2 /*return*/];
                    setSaving(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    result = serializeElements(elements);
                    return [4 /*yield*/, onSubmit(result)];
                case 2:
                    _b.sent();
                    setEditMode(false);
                    return [3 /*break*/, 5];
                case 3:
                    _a = _b.sent();
                    return [3 /*break*/, 5];
                case 4:
                    setSaving(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleClear = function () { return setElements([]); };
    var handleReset = function () { return setElements(parseGeneratedCodeFormat(value || '')); };
    var handleCancel = function () { return setEditMode(false); };
    if (!editMode) {
        return (_jsxs("span", { children: [_jsx("span", __assign({ className: "bold clickable", style: { width: 200, display: 'inline-block' }, onClick: startEdit }, { children: value || '' })), _jsx("span", __assign({ className: "margin20L" }, { children: intl.formatMessage(messages.Example) })), ":\u00A0", generateGeneratedCodeExample(value || '', firstNumber)] }));
    }
    return (_jsxs("div", __assign({ className: "numberFormatForm", id: "generatedCodeFormatInfo" }, { children: [_jsxs("div", __assign({ style: { marginBottom: 8, display: 'flex' } }, { children: [_jsx("label", __assign({ className: "margin10R form-control-static", style: { paddingLeft: 0 } }, { children: intl.formatMessage(messages.AddFormatParts) })), _jsxs("div", __assign({ role: "group" }, { children: [!hasCounter && (_jsx("button", __assign({ className: "btn btn-default", onClick: function () { return addPart('Counter'); }, title: intl.formatMessage(messages.Counter) }, { children: intl.formatMessage(messages.Counter) }))), _jsx("button", __assign({ className: "btn btn-default", onClick: function () { return addPart('Text'); }, title: intl.formatMessage(messages.Text) }, { children: intl.formatMessage(messages.Text) }))] }))] })), _jsx("br", {}), _jsx("div", __assign({ className: "dropzone" }, { children: elements.map(function (el, index) {
                    var _a;
                    return (_jsxs("div", __assign({ className: "bold part", style: { display: 'inline-block', margin: 2 } }, { children: [el.id === 'Counter' && (_jsx("span", __assign({ className: "bold margin5R" }, { children: intl.formatMessage(messages.CounterLabel) }))), _jsxs("div", __assign({ className: "options", style: { display: 'inline-block', margin: '0 4px' } }, { children: [el.id === 'Text' && (_jsx("input", { type: "text", className: "input-sm", size: 10, value: el.t || '', onChange: function (e) { return updatePart(index, { t: e.target.value }); } })), el.id === 'Counter' && (_jsx("input", { type: "number", className: "input-sm", min: 0, max: 9, style: { minWidth: 45 }, value: (_a = el.n) !== null && _a !== void 0 ? _a : 0, onChange: function (e) { return updatePart(index, { n: parseInt(e.target.value) || 0 }); } }))] })), index > 0 && (_jsx("a", __assign({ className: "clickable margin5R", onClick: function () { return movePart(index, index - 1); } }, { children: _jsx("i", { className: "fa fa-arrow-left" }) }))), index < elements.length - 1 && (_jsx("a", __assign({ className: "clickable margin5R", onClick: function () { return movePart(index, index + 1); } }, { children: _jsx("i", { className: "fa fa-arrow-right" }) }))), _jsx("a", __assign({ className: "clickable", onClick: function () { return removePart(index); } }, { children: _jsx("i", { className: "fa fa-times" }) }))] }), index));
                }) })), _jsxs("div", { children: [_jsx("span", { children: intl.formatMessage(messages.Example) }), _jsx("span", { children: ":\u00A0" }), _jsx("span", __assign({ className: "bold" }, { children: generateGeneratedCodeExample(elements) }))] }), firstNumber != null && (_jsxs("div", { children: [_jsx("span", { children: intl.formatMessage(messages.FirstNumber) }), _jsx("span", { children: ":\u00A0" }), _jsx("span", __assign({ className: "bold" }, { children: generateGeneratedCodeExample(elements, firstNumber) }))] })), _jsx("br", {}), showWarning && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "bold" }, { children: intl.formatMessage(messages.Warning) })), _jsx("br", {})] })), _jsxs("div", __assign({ className: "btn-group", role: "group" }, { children: [_jsxs("button", __assign({ className: "btn btn-inverse", onClick: handleSave, disabled: saving || !hasCounter }, { children: [saving && _jsx("i", { className: "fa fa-spinner fa-spin margin5R" }), intl.formatMessage(messages.Save)] })), _jsx("button", __assign({ className: "btn btn-default", onClick: handleClear }, { children: intl.formatMessage(messages.Clear) })), _jsx("button", __assign({ className: "btn btn-default", onClick: handleReset }, { children: intl.formatMessage(messages.Reset) })), _jsx("button", __assign({ className: "btn btn-default", onClick: handleCancel }, { children: intl.formatMessage(messages.Cancel) }))] }))] })));
};
export default EditableGeneratedCodeFormat;
